import React from 'react';
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components/macro';

import { useDataStore } from 'state/DataStore';

import Page from 'components/Page';
import ThumbnailGallery from 'components/ThumbnailGallery';

const RenderGallery = observer(() => {
    const dataStore = useDataStore();
    const { unitTypeSlug } = useParams();
    
    const unitType = dataStore.getItem('unit_types', 'slug', unitTypeSlug);
    const images = unitType?.acf?.render_gallery || [];

    return (
        <Page>
            <Inner>
                <ThumbnailGallery images={images} />
            </Inner>
        </Page>
    );
});

export default RenderGallery;

const Inner = styled.div`
    width: 100%;
    height: 100%;
    padding: 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;